export class PaymentCondition {
	id: number;
	payment_condition: string;
	description: string;
	user_created: string;
	user_modified: string;
	created_at: string;
	updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/payment_condition.ts